const en = {
  sortBy: 'Sort by',
  newContact: 'New contact',
  responsible: 'Responsible',
  stateFilter: 'Portfolio state',
  allOwners: 'All owners',
  allStates: 'All states',
  allLabels: 'All labels',
  labels: 'Labels',
  clearFilters: 'Clear filters',
  selectedCount: '{count} selected',
  selectContact: 'Select {name}',
  selectPage: 'Select current page',
  clearSelection: 'Clear selection',
  addLabels: 'Add labels',
  editLabels: 'Edit labels',
  options: 'Options for {name}',
  edit: 'Open / edit contact',
  editPortfolio: 'Edit portfolio',
  portfolioState: 'Portfolio state',
  selectOwner: 'Select an owner',
  portfolioOwnerRequired: 'Choose an owner for an owned portfolio.',
  portfolioSaved: 'Portfolio saved.',
  portfolioError: 'Could not save the portfolio. Please try again.',
  portfolioEditHelp:
    'Changing a portfolio never changes the assignee of an active conversation.',
  save: 'Save',
  labelsSaved: 'Labels saved.',
  partialError:
    'Some contacts could not be updated. The list shows the saved changes; select the remaining contacts to retry.',
  created: 'Contact created.',
  actionError: 'Could not save. Please try again.',
  noLabels: 'No labels available in this account.',
  title: 'Contacts',
  mine: 'My portfolio',
  available: 'Re-engagement',
  all: 'Manage contacts',
  search: 'Search name, email or phone',
  mineHint: 'Your customers, with commercial context in one place.',
  availableHint: 'Contacts explicitly available for re-engagement.',
  allHint: 'Review the customer base and portfolio ownership.',
  owner: 'Portfolio owner',
  seller: 'Last order seller',
  interaction: 'Last commercial interaction',
  expiry: 'Portfolio deadline',
  order: 'Last order',
  current: 'Current service',
  history: 'Conversations',
  none: 'Not recorded',
  unowned: 'No owner',
  owned: 'In portfolio',
  unclassified: 'Unclassified',
  availableState: 'Available for re-engagement',
  historyButton: 'Open contact',
  back: 'Back to contacts',
  readOnly: 'Viewing this contact does not change its owner.',
  policy:
    'Dates are recorded information. Automatic renewal and distribution are not enabled.',
  empty: 'No contacts in this view',
  emptyHint: 'Try a different search or switch views.',
  error: 'Could not load contacts.',
  retry: 'Try again',
  loading: 'Loading contacts…',
  historyError: 'Could not load conversations.',
  historyEmpty: 'No conversations available.',
  contact: 'Contact',
  prev: 'Previous page',
  next: 'Next page',
  pagination: '{count} contacts · Page {page}',
  noInteraction: 'No commercial interaction recorded',
  days: '{days} days since last interaction',
  remaining: '{days} days remaining',
  overdue: 'Recorded deadline passed',
  conversation: 'Conversation #{id}',
  open: 'Open',
  resolved: 'Resolved',
  pending: 'Pending',
  snoozed: 'Snoozed',
};
const pt = {
  sortBy: 'Ordenar por',
  newContact: 'Novo contato',
  responsible: 'Responsável',
  stateFilter: 'Situação da carteira',
  allOwners: 'Todos os responsáveis',
  allStates: 'Todas as situações',
  allLabels: 'Todas as etiquetas',
  labels: 'Etiquetas',
  clearFilters: 'Limpar filtros',
  selectedCount: '{count} selecionados',
  selectContact: 'Selecionar {name}',
  selectPage: 'Selecionar página atual',
  clearSelection: 'Limpar seleção',
  addLabels: 'Adicionar etiquetas',
  editLabels: 'Editar etiquetas',
  options: 'Opções de {name}',
  edit: 'Abrir / editar contato',
  save: 'Salvar',
  labelsSaved: 'Etiquetas salvas.',
  partialError:
    'Alguns contatos não puderam ser atualizados. A lista mostra as alterações salvas; selecione os contatos restantes para tentar novamente.',
  created: 'Contato criado.',
  actionError: 'Não foi possível salvar. Tente novamente.',
  noLabels: 'Nenhuma etiqueta disponível nesta conta.',
  title: 'Contatos',
  mine: 'Minha carteira',
  available: 'Repescagem',
  all: 'Gestão da base',
  search: 'Buscar nome, e-mail ou telefone',
  mineHint: 'Seus clientes, com o contexto comercial em um só lugar.',
  availableHint: 'Contatos disponíveis para retomada.',
  allHint: 'Consulte a base e os responsáveis pelas carteiras.',
  owner: 'Carteira',
  seller: 'Último vendedor',
  interaction: 'Última interação',
  expiry: 'Prazo',
  order: 'Último pedido',
  current: 'Atendimento atual',
  history: 'Conversas',
  none: 'Não registrado',
  unowned: 'Sem responsável',
  owned: 'Na carteira',
  unclassified: 'Não classificado',
  availableState: 'Disponível para repescagem',
  historyButton: 'Abrir contato',
  back: 'Voltar aos contatos',
  readOnly: 'Consultar este contato não altera o responsável.',
  policy:
    'Datas registradas. Renovação automática e distribuição ainda não estão habilitadas.',
  empty: 'Nenhum contato nesta visualização',
  emptyHint: 'Tente outra busca ou troque de visualização.',
  error: 'Não foi possível carregar os contatos.',
  retry: 'Tentar novamente',
  loading: 'Carregando contatos…',
  historyError: 'Não foi possível carregar as conversas.',
  historyEmpty: 'Nenhuma conversa disponível.',
  contact: 'Contato',
  prev: 'Página anterior',
  next: 'Próxima página',
  pagination: '{count} contatos · Página {page}',
  noInteraction: 'Sem interação comercial registrada',
  days: 'Sem interação há {days} dias',
  remaining: 'Restam {days} dias',
  overdue: 'Prazo registrado vencido',
  conversation: 'Conversa #{id}',
  open: 'Aberta',
  resolved: 'Resolvida',
  pending: 'Pendente',
  snoozed: 'Adiada',
};
export default { en, pt, pt_BR: pt };
